import React, { useContext, useEffect } from 'react'
import { UserDataContext } from '../context/UserContext'
import { useNavigate } from 'react-router-dom'

const PublicUserWrapper = ({ children }) => {
    const { user, isLoading } = useContext(UserDataContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && user && user.authenticated) {
            if (user.role === 'COLLECTOR') {
                navigate('/collectors-home');
            } else if (user.role === 'ADMIN') {
                navigate('/');
            }
        }
    }, [user, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00BFA5]"></div>
            </div>
        );
    }

    // Only render children (login forms) if NOT authenticated
    if (user && user.authenticated) {
        return null;
    }

    return <>{children}</>;
}

export default PublicUserWrapper;
